import { useEffect, useRef, useCallback } from 'react';
import { io, type Socket } from 'socket.io-client';
import { useAuth } from '../context/AuthContext';

export function useSocket() {
  const { user, token } = useAuth();
  const socketRef = useRef<Socket | null>(null);

  useEffect(() => {
    if (!user || !token) return;

    const socket = io('/', {
      path: '/socket.io',
      transports: ['websocket', 'polling'],
      auth: { token },
      autoConnect: false,
    });

    socketRef.current = socket;
    // React StrictMode monta e desmonta efeitos uma vez em desenvolvimento.
    // Adiar o handshake evita abrir um WebSocket que será fechado imediatamente.
    const connectTimer = window.setTimeout(() => socket.connect(), 0);

    return () => {
      window.clearTimeout(connectTimer);
      socket.removeAllListeners();
      socket.disconnect();
      socketRef.current = null;
    };
  }, [user?.sub, token]);

  const on = useCallback(
    (event: string, callback: (...args: any[]) => void) => {
      const socket = socketRef.current;
      if (!socket) return () => {};
      socket.on(event, callback);
      return () => {
        socket.off(event, callback);
      };
    },
    [],
  );

  return { on, socket: socketRef.current };
}
